(function (root) {
  'use strict';
  function cakes(catalog) {
    return (catalog || []).filter(function (p) { return p.published === true && p.available === true && p.collection === 'bolos' && Array.isArray(p.variants) && p.variants.some(function (v) { return v && v.available === true && v.id != null && Number.isInteger(v.priceCents) && v.priceCents > 0; }); });
  }
  function validateSelection(ids, catalog) {
    var allowed = cakes(catalog).map(function (p) { return p.handle; });
    if (!Array.isArray(ids) || ids.length < 2 || ids.length > 3 || new Set(ids).size !== ids.length || ids.some(function (id) { return !allowed.includes(id); })) throw new Error('Escolha dois ou três bolos disponíveis.');
    return ids.slice();
  }
  function shareURL(base, id) {
    if (!/^[a-f0-9]{36}$/.test(id)) throw new Error('Votação inválida.');
    var url = new URL(base);
    url.search = ''; url.hash = '';
    url.searchParams.set('votacao', id);
    return url.href;
  }
  function escape(value) { return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function mount(el, catalog, endpoint) {
    if (!el || !endpoint) return;
    var products = cakes(catalog), selected = [], poll = null, busy = false, memoryToken = '';
    var base = new URL(endpoint, root.location.href);
    if (base.protocol !== 'https:' && !['localhost', '127.0.0.1'].includes(base.hostname)) return;
    endpoint = base.href.replace(/\/$/, '');
    el.hidden = false;
    function metric(name, count) {
      if (typeof root.LTrack === 'function') root.LTrack(name, { option_count: count });
    }
    function token() {
      var key = 'larrysa-vote-' + poll.id;
      try {
        var saved = JSON.parse(root.localStorage.getItem(key));
        if (saved && saved.expires > Date.now() && /^[a-f0-9]{64}$/.test(saved.token)) return saved.token;
      } catch (error) {}
      if (!memoryToken) memoryToken = Array.from(root.crypto.getRandomValues(new Uint8Array(32)), function (b) { return b.toString(16).padStart(2, '0'); }).join('');
      try { root.localStorage.setItem(key, JSON.stringify({ token: memoryToken, expires: poll.expiresAt })); } catch (error) {}
      return memoryToken;
    }
    async function request(path, body) {
      var response = await root.fetch(endpoint + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), credentials: 'omit' } : { credentials: 'omit' });
      if (!response.ok) throw new Error(response.status === 404 ? 'Esta votação terminou ou já não está disponível.' : 'Não foi possível guardar. Tente novamente.');
      return response.json();
    }
    function status(text) { el.querySelector('[data-group-status]').textContent = text; }
    function render() {
      var list = poll ? poll.options.map(function (id) { return products.find(function (p) { return p.handle === id; }) || { handle: id, title: 'Produto já indisponível' }; }) : products;
      el.innerHTML = '<h2>Escolha o bolo em conjunto</h2><p>Escolha dois ou três bolos e partilhe a votação com o grupo. Os votos ajudam a decidir; não fazem uma encomenda.</p>' +
        '<p class="group-choice__privacy">A votação termina ao fim de sete dias. Não pedimos nomes, emails ou telefones. Ao votar, guardamos neste navegador uma chave aleatória para poderes alterar ou retirar o voto. Quem tiver a ligação pode ver o resultado. É uma consulta informal, sem garantia de um voto por pessoa.</p>' +
        '<div class="group-choice__grid">' + list.map(function (p) {
          var available = products.some(function (candidate) { return candidate.handle === p.handle; });
          var count = poll ? Number(poll.votes[p.handle]) || 0 : 0;
          return '<div class="group-choice__item"><h3>' + escape(p.title) + '</h3>' +
            (poll ? '<p>' + count + (count === 1 ? ' voto' : ' votos') + '</p><button type="button" data-vote="' + escape(p.handle) + '"' + (!available ? ' disabled' : '') + '>Votar neste bolo</button>' +
              (available ? '<button type="button" data-use="' + escape(p.handle) + '">Usar no pedido</button>' : '') :
              '<label><input type="checkbox" data-select="' + escape(p.handle) + '"' + (selected.includes(p.handle) ? ' checked' : '') + '> Incluir na votação</label>') + '</div>';
        }).join('') + '</div>' +
        (poll ? '<button type="button" data-share>Partilhar votação</button><button type="button" data-refresh>Atualizar resultados</button><button type="button" data-withdraw>Retirar o meu voto</button>' : '<button type="button" data-create>Criar votação</button>') +
        '<p role="status" aria-live="polite" data-group-status></p><input type="url" aria-label="Ligação da votação" data-share-link hidden readonly>';
      el.querySelectorAll('[data-select]').forEach(function (input) { input.addEventListener('change', function () {
        var id = input.getAttribute('data-select');
        if (input.checked && selected.length >= 3) { input.checked = false; status('Pode escolher até três bolos.'); return; }
        selected = input.checked ? selected.concat(id) : selected.filter(function (item) { return item !== id; });
        status(selected.length + ' de 3 bolos selecionados.');
      }); });
      el.querySelectorAll('button').forEach(function (button) { button.addEventListener('click', async function () {
        if (busy) return;
        busy = true; button.disabled = true;
        try {
          if (button.hasAttribute('data-create')) {
            poll = await request('/polls', { options: validateSelection(selected, catalog) });
            root.history.replaceState(null, '', shareURL(root.location.href, poll.id));
            metric('group_choice_created', poll.options.length); render(); status('Votação criada. Partilhe a ligação com o grupo.');
          } else if (button.hasAttribute('data-vote')) {
            poll = await request('/polls/' + poll.id + '/votes', { choice: button.getAttribute('data-vote'), token: token() });
            metric('group_choice_voted', poll.options.length); render(); status('Voto guardado. Pode alterá-lo ou retirá-lo.');
          } else if (button.hasAttribute('data-withdraw')) {
            poll = await request('/polls/' + poll.id + '/withdraw', { token: token() });
            render(); status('O seu voto foi retirado.');
          } else if (button.hasAttribute('data-refresh')) {
            poll = await request('/polls/' + poll.id); render(); status('Resultados atualizados.');
          } else if (button.hasAttribute('data-use')) {
            root.document.dispatchEvent(new CustomEvent('larrysa:group-choice-selected', { detail: { handle: button.getAttribute('data-use') } }));
            metric('group_choice_used', poll.options.length); status('Bolo incluído no pedido. Completa os dados da festa abaixo.');
            root.document.getElementById('planner')?.scrollIntoView({ block: 'start' });
          } else if (button.hasAttribute('data-share')) {
            var url = shareURL(root.location.href, poll.id);
            var input = el.querySelector('[data-share-link]'); input.hidden = false; input.value = url;
            if (root.navigator.share) { await root.navigator.share({ title: 'Qual é o bolo favorito do grupo?', url: url }); metric('group_choice_shared', poll.options.length); }
            else if (root.navigator.clipboard) { await root.navigator.clipboard.writeText(url); metric('group_choice_link_copied', poll.options.length); status('Ligação copiada.'); }
            else { input.focus(); input.select(); status('Copie esta ligação para partilhar.'); }
          }
        } catch (error) { if (error.name !== 'AbortError') status(error.message); }
        finally { busy = false; button.disabled = false; }
      }); });
    }
    render();
    var id = new URL(root.location.href).searchParams.get('votacao');
    if (id) {
      if (!/^[a-f0-9]{36}$/.test(id)) { status('Ligação de votação inválida.'); return; }
      busy = true; status('A abrir a votação…');
      request('/polls/' + id).then(function (result) { poll = result; render(); }).catch(function (error) { status(error.message); }).finally(function () { busy = false; });
    }
  }
  root.LarrysaGroupChoice = { validateSelection: validateSelection, shareURL: shareURL, mount: mount };
  if (root.document) {
    var el = root.document.getElementById('group-choice');
    mount(el, root.LARRYSA_SHOPIFY_CATALOG, el && el.getAttribute('data-endpoint'));
  }
})(typeof window !== 'undefined' ? window : globalThis);
